var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner__container"},[_c('span',{staticClass:"spinner"}),_c('span',{staticClass:"texto"},[_vm._v("Carregando dados...")])])}]

export { render, staticRenderFns }